// Test IDs de Configuración (datos de la academia).

export const CLINIC = {
  nameInput: 'clinic-name-input',
  addressInput: 'clinic-address-input',
  phoneInput: 'clinic-phone-input',
  emailInput: 'clinic-email-input',
  whatsappInput: 'clinic-whatsapp-input',
  timezoneSelect: 'clinic-timezone-select',
  logoUpload: 'clinic-logo-upload',
  saveButton: 'clinic-save-button',
};
